var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.state.isKiosk)?_c('KioskDashboard'):(this.$store.state.user.type < 3)?_c('ResellerDashboard'):(this.$store.state.user.type == 3)?_c('ClientDashboard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }